import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "hierarchy-container" }
const _hoisted_2 = {
  key: 0,
  ref: "showGroupMenu",
  class: "folder-options-menu animated-fast"
}
const _hoisted_3 = {
  key: 0,
  ref: "showSubgroupMenu",
  class: "folder-options-menu animated-fast"
}
const _hoisted_4 = { class: "dialog-card warning" }
const _hoisted_5 = { class: "dialog-title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-triangle" }, null, -1)
const _hoisted_7 = {
  class: "dialog-body",
  style: {"gap":"15px","display":"flex","flex-direction":"column"}
}
const _hoisted_8 = { class: "dialog-actions" }
const _hoisted_9 = { style: {"margin-left":"auto","display":"flex"} }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "dialog-bottom" }, null, -1)
const _hoisted_11 = { class: "dialog-card warning" }
const _hoisted_12 = { class: "dialog-title" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-triangle" }, null, -1)
const _hoisted_14 = {
  class: "dialog-body",
  style: {"gap":"15px","display":"flex","flex-direction":"column"}
}
const _hoisted_15 = { class: "dialog-actions" }
const _hoisted_16 = { style: {"margin-left":"auto","display":"flex"} }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "dialog-bottom" }, null, -1)
const _hoisted_18 = { class: "dialog-card warning" }
const _hoisted_19 = { class: "dialog-title" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-triangle" }, null, -1)
const _hoisted_21 = {
  class: "dialog-body",
  style: {"gap":"15px","display":"flex","flex-direction":"column"}
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = { class: "dialog-actions" }
const _hoisted_25 = { style: {"margin-left":"auto","display":"flex"} }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "dialog-bottom" }, null, -1)
const _hoisted_27 = { class: "dialog-card warning" }
const _hoisted_28 = { class: "dialog-title" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-triangle" }, null, -1)
const _hoisted_30 = { class: "dialog-body" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "dialog-actions" }
const _hoisted_35 = { style: {"margin-left":"auto","display":"flex"} }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "dialog-bottom" }, null, -1)
const _hoisted_37 = { class: "dialog-card warning" }
const _hoisted_38 = { class: "dialog-title" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-triangle" }, null, -1)
const _hoisted_40 = {
  key: 0,
  class: "dialog-body"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_43 = {
  key: 1,
  class: "dialog-body",
  style: {"max-height":"300px","overflow-y":"auto"}
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "dialog-actions" }
const _hoisted_48 = { style: {"margin-left":"auto","display":"flex"} }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "dialog-bottom" }, null, -1)
const _hoisted_50 = { class: "hierarchy-top" }
const _hoisted_51 = { class: "hierarchy-accordion" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = {
  key: 0,
  class: "hierarchy-group-content"
}
const _hoisted_54 = ["onContextmenu", "onClick"]
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["src"]
const _hoisted_57 = { style: {"color":"#aeaeae"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_text_field = _resolveComponent("imdex-text-field")!
  const _component_imdex_btn = _resolveComponent("imdex-btn")!
  const _component_imdex_dialog = _resolveComponent("imdex-dialog")!
  const _component_imdex_select = _resolveComponent("imdex-select")!
  const _component_Folder = _resolveComponent("Folder")!
  const _component_Dataset = _resolveComponent("Dataset")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      enterActiveClass: "zoomIn2",
      leaveActiveClass: "fadeOutDown"
    }, {
      default: _withCtx(() => [
        (_ctx.showGroupMenu)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", {
                  onMousedown: _cache[0] || (_cache[0] = ($event: any) => (_ctx.importInto('drillhole')))
                }, _toDisplayString(_ctx.$t(`ssa.hierarchy.index.importDh`)), 33),
                _createElementVNode("li", {
                  onMousedown: _cache[1] || (_cache[1] = ($event: any) => (_ctx.importInto('blockmodel')))
                }, _toDisplayString(_ctx.$t(`ssa.hierarchy.index.impBm`)), 33),
                _createElementVNode("li", {
                  onMousedown: _cache[2] || (_cache[2] = ($event: any) => (_ctx.importInto('shape')))
                }, _toDisplayString(_ctx.$t(`ssa.hierarchy.index.impSurf`)), 33),
                _createElementVNode("li", {
                  onMousedown: _cache[3] || (_cache[3] = ($event: any) => (_ctx.importInto('point')))
                }, _toDisplayString(_ctx.$t(`ssa.hierarchy.index.impPts`)), 33)
              ])
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      enterActiveClass: "zoomIn2",
      leaveActiveClass: "fadeOutDown"
    }, {
      default: _withCtx(() => [
        (_ctx.showSubgroupMenu)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", {
                  onMousedown: _cache[4] || (_cache[4] = ($event: any) => (_ctx.importInto(_ctx.activeDatasetType.toLowerCase())))
                }, _toDisplayString(_ctx.activeGroup === _ctx.BD_DS_NAME && _ctx.hasBlastDogDatasets
								? _ctx.$t(`ssa.hierarchy.update`)
								: _ctx.$t(`ssa.hierarchy.import`)), 33),
                (_ctx.activeGroup !== 'BLASTDOG')
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      onMousedown: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addFolderInto && _ctx.addFolderInto(...args)))
                    }, _toDisplayString(_ctx.$t(`ssa.hierarchy.index.addFolder`)), 33))
                  : _createCommentVNode("", true)
              ])
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_imdex_dialog, {
      width: "550",
      value: _ctx.createGroupDialog,
      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.createGroupDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(_ctx.$t(`ssa.hierarchy.index.createGroup`)), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_imdex_text_field, {
              label: _ctx.$t(`ssa.hierarchy.index.newGroupInputLabel`),
              value: _ctx.newGroupName,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newGroupName) = $event))
            }, null, 8, ["label", "value"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_imdex_btn, {
                disabled: _ctx.createGroupLoading,
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.createGroupDialog = false)),
                text: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`ssa.hierarchy.index.createGroup`)), 1)
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_imdex_btn, {
                loading: _ctx.createGroupLoading,
                disabled: _ctx.newGroupName == '' || _ctx.createGroupLoading,
                style: {"margin-left":"10px"},
                onClick: _ctx.createGroup
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`ssa.hierarchy.index.OK`)), 1)
                ]),
                _: 1
              }, 8, ["loading", "disabled", "onClick"])
            ])
          ]),
          _hoisted_10
        ])
      ]),
      _: 1
    }, 8, ["value"]),
    _createVNode(_component_imdex_dialog, {
      width: "550",
      value: _ctx.confirmMove,
      "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.confirmMove) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createTextVNode(" " + _toDisplayString(_ctx.$t(`ssa.hierarchy.index.moveDataset`)), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_imdex_select, {
              value: _ctx.folderToMoveTo,
              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.folderToMoveTo) = $event)),
              items: _ctx.foldersInGroup,
              label: _ctx.$t(`ssa.hierarchy.index.folder`)
            }, null, 8, ["value", "items", "label"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_imdex_btn, {
                disabled: _ctx.moveDatasetLoading,
                onClick: _cache[10] || (_cache[10] = ($event: any) => ((_ctx.confirmMove = false), (_ctx.folderToMoveTo = 'Select'))),
                text: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`ssa.hierarchy.index.cancel`)), 1)
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_imdex_btn, {
                loading: _ctx.moveDatasetLoading,
                disabled: 
								_ctx.groupToMoveTo == 'Select' ||
								_ctx.folderToMoveTo == 'Select' ||
								_ctx.moveDatasetLoading
							,
                style: {"margin-left":"10px"},
                onClick: _ctx.moveDataset
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`ssa.hierarchy.index.ok`)), 1)
                ]),
                _: 1
              }, 8, ["loading", "disabled", "onClick"])
            ])
          ]),
          _hoisted_17
        ])
      ]),
      _: 1
    }, 8, ["value"]),
    _createVNode(_component_imdex_dialog, {
      width: "550",
      value: _ctx.acceptRenameSuggestionModal,
      "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.acceptRenameSuggestionModal) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createTextVNode(" " + _toDisplayString(_ctx.renameSuggestionReason) + " " + _toDisplayString(_ctx.renameSuggestionTarget) + " " + _toDisplayString(_ctx.$t(`ssa.hierarchy.index.errorExists`)), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createTextVNode(_toDisplayString(_ctx.$t(`ssa.hierarchy.index.renameSuggest`, {
							renameSuggestionOldName: _ctx.renameSuggestionOldName,
							renameSuggestionNewName: _ctx.renameSuggestionNewName
						})) + " ", 1),
            _hoisted_22,
            _hoisted_23,
            _createTextVNode(_toDisplayString(_ctx.$t(`ssa.hierarchy.index.errorExistsExpl`, {
							renameSuggestionTarget: _ctx.renameSuggestionTarget.toLocaleLowerCase()
						})), 1)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_imdex_btn, {
                disabled: _ctx.acceptRenameSuggestionLoading,
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.acceptRenameSuggestionModal = false)),
                text: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`ssa.hierarchy.index.cancel`)), 1)
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_imdex_btn, {
                loading: _ctx.acceptRenameSuggestionLoading,
                disabled: _ctx.acceptRenameSuggestionLoading,
                style: {"margin-left":"10px"},
                onClick: _ctx.acceptRenameSuggestion
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`ssa.hierarchy.index.ok`)), 1)
                ]),
                _: 1
              }, 8, ["loading", "disabled", "onClick"])
            ])
          ]),
          _hoisted_26
        ])
      ]),
      _: 1
    }, 8, ["value"]),
    _createVNode(_component_imdex_dialog, {
      width: "550",
      value: _ctx.confirmDelete,
      "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.confirmDelete) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createTextVNode(" " + _toDisplayString(_ctx.$t(`ssa.hierarchy.index.cancel`)), 1)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createTextVNode(_toDisplayString(_ctx.highlighted.length > 1
							? _ctx.$t(`ssa.hierarchy.index.confirmDeletes`)
							: _ctx.$t(`ssa.hierarchy.index.confirmDelete`)), 1),
            _hoisted_31,
            _hoisted_32,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDatasetsFromHighlighted(), (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                style: {"display":"flex","align-items":"center","gap":"10px"},
                key: i
              }, [
                _createElementVNode("img", {
                  style: {"width":"15px"},
                  src: _ctx.$data[item.dataType as keyof typeof $data],
                  alt: ""
                }, null, 8, _hoisted_33),
                _createTextVNode(" " + _toDisplayString(item.name), 1)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_imdex_btn, {
                disabled: _ctx.loadingDeletingDatasets,
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.confirmDelete = false)),
                text: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`ssa.hierarchy.index.cancel`)), 1)
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_imdex_btn, {
                disabled: _ctx.loadingDeletingDatasets,
                loading: _ctx.loadingDeletingDatasets,
                style: {"margin-left":"10px"},
                onClick: _ctx.deleteDataset
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`ssa.hierarchy.index.ok`)), 1)
                ]),
                _: 1
              }, 8, ["disabled", "loading", "onClick"])
            ])
          ]),
          _hoisted_36
        ])
      ]),
      _: 1
    }, 8, ["value"]),
    _createVNode(_component_imdex_dialog, {
      width: "550",
      value: _ctx.confirmFolderDelete,
      "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.confirmFolderDelete) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createTextVNode(" " + _toDisplayString(_ctx.$t(`ssa.hierarchy.index.deleteFolder`)), 1)
          ]),
          (_ctx.getDatasetsFromFolder(_ctx.folderNameToDelete).length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createTextVNode(_toDisplayString(_ctx.$t(`ssa.hierarchy.index.confirmDeleteFolder`)) + " " + _toDisplayString(`${_ctx.folderNameToDelete}`), 1),
                _hoisted_41,
                _hoisted_42
              ]))
            : _createCommentVNode("", true),
          (_ctx.getDatasetsFromFolder(_ctx.folderNameToDelete).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                _createTextVNode(_toDisplayString(_ctx.$t(`ssa.hierarchy.index.confirmDeletesInFolder`)), 1),
                _hoisted_44,
                _hoisted_45,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDatasetsFromFolder(_ctx.folderNameToDelete), (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    style: {"display":"flex","align-items":"center","gap":"10px"},
                    key: i
                  }, [
                    _createElementVNode("img", {
                      style: {"width":"15px"},
                      src: _ctx.$data[item.dataType as keyof typeof $data],
                      alt: ""
                    }, null, 8, _hoisted_46),
                    _createTextVNode(" " + _toDisplayString(item.name), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _createVNode(_component_imdex_btn, {
                disabled: _ctx.loadingDeletingDatasets,
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.confirmFolderDelete = false)),
                text: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`ssa.hierarchy.index.cancel`)), 1)
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_imdex_btn, {
                loading: _ctx.loadingDeletingDatasets,
                disabled: _ctx.loadingDeletingDatasets,
                style: {"margin-left":"10px"},
                onClick: _ctx.deleteFolder
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`ssa.hierarchy.index.ok`)), 1)
                ]),
                _: 1
              }, 8, ["loading", "disabled", "onClick"])
            ])
          ]),
          _hoisted_49
        ])
      ]),
      _: 1
    }, 8, ["value"]),
    _createElementVNode("div", _hoisted_50, [
      _createVNode(_component_imdex_text_field, {
        small: "",
        label: _ctx.$t(`ssa.hierarchy.index.searchInputLabel`),
        value: _ctx.searchTermTemp,
        "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.searchTermTemp) = $event)),
        leadingIcon: "fal fa-search"
      }, null, 8, ["label", "value"]),
      _createVNode(_component_imdex_btn, {
        onClick: _cache[19] || (_cache[19] = ($event: any) => ((_ctx.searchTermTemp = ''), _ctx.fetchHierarchy())),
        icon: "",
        fab: "",
        compact: "",
        text: "",
        secondary: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("i", {
            class: _normalizeClass(["fal fa-sync animated", { spin: _ctx.loadingHierarchy }])
          }, null, 2)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_51, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hierarchyStore.hierarchy, (group, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["hierarchy-group-item", { active: _ctx.activeGroups.includes(group.name) }]),
          key: i
        }, [
          _createElementVNode("div", {
            onClick: _withModifiers(($event: any) => (
						_ctx.activeGroup != group.name ? _ctx.toggleGroupOpen(group.name) : (_ctx.activeGroup = '')
					), ["stop","exact"]),
            class: "hierarchy-group-name"
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(["fa fa-caret-right", { 'rotate-this': _ctx.activeGroups.includes(group.name) }])
            }, null, 2),
            _createTextVNode(_toDisplayString(group.name), 1)
          ], 8, _hoisted_52),
          (_ctx.activeGroups.includes(group.name) || _ctx.searchTerm.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.children, (datasetType, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "hierarchy-bucket",
                    key: i
                  }, [
                    _createElementVNode("div", {
                      onContextmenu: _withModifiers(($event: any) => (
								(_ctx.activeGroup = group.name),
									(_ctx.activeDatasetType = datasetType.name),
									_ctx.toggleSubgroupRightClickMenu('right', $event)
							), ["right","stop","prevent"]),
                      onClick: _withModifiers(($event: any) => (
								_ctx.toggleSubGroupOpen(group.name + '::' + datasetType.name)
								// activeDatasetType == datasetType.name ? (activeDatasetType = '') : (activeDatasetType = datasetType.name)
							), ["exact"]),
                      class: "hierarchy-subgroup-name"
                    }, [
                      _createElementVNode("i", {
                        onClick: _withModifiers(($event: any) => (
									_ctx.toggleSubGroupOpen(group.name + '::' + datasetType.name)
								), ["stop"]),
                        class: _normalizeClass(["fa fa-caret-right", {
									expanded:
										_ctx.activeSubGroups.includes(
											group.name + '::' + datasetType.name
										) || _ctx.searchTerm.length > 0
								}])
                      }, null, 10, _hoisted_55),
                      _createElementVNode("img", {
                        style: {"width":"15px"},
                        src: _ctx.$data[datasetType.name as keyof typeof $data]
                      }, null, 8, _hoisted_56),
                      _createTextVNode(" " + _toDisplayString(datasetType.name) + " ", 1),
                      _createElementVNode("span", _hoisted_57, "(" + _toDisplayString(_ctx.allDatasets.filter((dataset) => {
										return (
											dataset.dataType == datasetType.name &&
											(dataset.groupName == group.name ||
												dataset.groupName == datasetType.name)
										);
									}).length) + ")", 1)
                    ], 40, _hoisted_54),
                    _createElementVNode("div", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datasetType.children, (folder, d) => {
                        return _withDirectives((_openBlock(), _createElementBlock("div", {
                          style: {"margin-left":"20px"},
                          key: d
                        }, [
                          _withDirectives((_openBlock(), _createBlock(_component_Folder, {
                            onImportIntoFolder: _cache[20] || (_cache[20] = ($event) => _ctx.importIntoFolder($event)),
                            onDeleteFolder: _cache[21] || (_cache[21] = 
										($event) => {
											_ctx.$data.confirmFolderDelete = true;
											_ctx.$data.folderNameToDelete = $event;
										}
									),
                            onDeleteDataset: _cache[22] || (_cache[22] = ($event: any) => (_ctx.confirmDelete = true)),
                            onRenameDataset: _ctx.renameDataset,
                            onRenameFolder: _ctx.renameFolder,
                            onMoveDataset: _cache[23] || (_cache[23] = ($event: any) => (_ctx.confirmMove = true)),
                            key: d,
                            onSelect: _ctx.dataSelect,
                            onHighlight: _ctx.dataHighlight,
                            onSetActiveGroup: _ctx.setActiveGroup,
                            onSetActiveDatasetType: _ctx.setActiveDatasetType,
                            onSetDefaultMoveGroup: _ctx.setDefaultMoveGroup,
                            dataType: datasetType.name,
                            name: folder.name,
                            selected: _ctx.selected,
                            highlighted: _ctx.highlighted,
                            children: folder.children,
                            datasets: folder.datasets ?? [],
                            searchTerm: _ctx.searchTerm,
                            groupName: group.name,
                            latestUploadedDatasetId: _ctx.eventStore.getLatestUploadedDatasetId,
                            latestUploadedDatasetFolderPath: 
										_ctx.eventStore.getLatestUploadedDatasetFolderPath
									
                          }, null, 8, ["onRenameDataset", "onRenameFolder", "onSelect", "onHighlight", "onSetActiveGroup", "onSetActiveDatasetType", "onSetDefaultMoveGroup", "dataType", "name", "selected", "highlighted", "children", "datasets", "searchTerm", "groupName", "latestUploadedDatasetId", "latestUploadedDatasetFolderPath"])), [
                            [_vShow, 
										(_ctx.activeGroups.includes(group.name) &&
											_ctx.activeSubGroups.includes(
												group.name + '::' + datasetType.name
											)) ||
										_ctx.searchTerm.length > 0
									]
                          ])
                        ])), [
                          [_vShow, true]
                        ])
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datasetType.datasets, (dataset, d) => {
                        return _withDirectives((_openBlock(), _createElementBlock("div", {
                          style: {"margin-left":"20px"},
                          key: 
									d +
									'_' +
									Object.values(dataset.paraviewLayersInfoSplit).find(
										(item) =>
											item.layerConfigType ===
												_ctx.NonDrillholeLayerConfigTypeTmp ||
											item.layerConfigType ===
												_ctx.CollarDrillholeLayerConfigTypeTmp
									)?.hierarchies.length
								
                        }, [
                          _createVNode(_component_Dataset, {
                            onDeleteDataset: _cache[24] || (_cache[24] = ($event: any) => (_ctx.confirmDelete = true)),
                            onRenameDataset: _ctx.renameDataset,
                            onMoveDataset: _cache[25] || (_cache[25] = ($event: any) => (_ctx.confirmMove = true)),
                            onSelect: _ctx.dataSelect,
                            onHighlight: _ctx.dataHighlight,
                            onClearHighlights: _ctx.clearHighlightedDatasets,
                            onSetActiveGroup: _ctx.setActiveGroup,
                            onSetActiveDatasetType: _ctx.setActiveDatasetType,
                            onSetDefaultMoveGroup: _ctx.setDefaultMoveGroup,
                            onUpdateBlastDogDataset: _ctx.importInto,
                            id: dataset.id,
                            name: dataset.name,
                            status: dataset.status,
                            selected: _ctx.selected,
                            highlighted: _ctx.highlighted,
                            searchTerm: _ctx.searchTerm,
                            isDatasetTop: true,
                            dataType: datasetType.name,
                            isGAS: dataset.isGAS,
                            paraviewVisHierarchies: 
										Object.values(dataset.paraviewLayersInfoSplit).find(
											(item) =>
												item.layerConfigType ===
													_ctx.NonDrillholeLayerConfigTypeTmp ||
												item.layerConfigType ===
													_ctx.CollarDrillholeLayerConfigTypeTmp
										)?.hierarchies
									,
                            groupName: group.name
                          }, null, 8, ["onRenameDataset", "onSelect", "onHighlight", "onClearHighlights", "onSetActiveGroup", "onSetActiveDatasetType", "onSetDefaultMoveGroup", "onUpdateBlastDogDataset", "id", "name", "status", "selected", "highlighted", "searchTerm", "dataType", "isGAS", "paraviewVisHierarchies", "groupName"])
                        ])), [
                          [_vShow, 
									(_ctx.activeGroups.includes(group.name) &&
										_ctx.activeSubGroups.includes(
											group.name + '::' + datasetType.name
										)) ||
									_ctx.searchTerm.length > 0
								]
                        ])
                      }), 128))
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ])
  ]))
}